import { render, staticRenderFns } from "./context-table.vue?vue&type=template&id=382396b0&"
import script from "./context-table.vue?vue&type=script&lang=js&"
export * from "./context-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports